/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Coord_LatInputs */

const vi_grower_coord_lat = /** @type {(inputs: Grower_Coord_LatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vĩ độ`)
};

/**

* @param {Grower_Coord_LatInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_coord_lat = /** @type {((inputs?: Grower_Coord_LatInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Coord_LatInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_coord_lat(inputs)
});